// JOBE-0160.1/.5: CommandCenter entry, RosterTable wired.
import { useFlagStore } from './lib/useFlagStore.js';
import { useDocumentTitle } from './lib/useDocumentTitle.js';
import { KpiRow } from './CommandCenter/KpiRow.jsx';
import { AttentionList } from './CommandCenter/AttentionList.jsx';
import { RiskHeatMap } from './CommandCenter/RiskHeatMap.jsx';
import { TrendPanel } from './CommandCenter/TrendPanel.jsx';
import { RosterTable } from './CommandCenter/RosterTable.jsx';
import { DisabledRoutePlaceholder } from './components/DisabledRoutePlaceholder.jsx';
import './mock-wcc.js';
export function CommandCenter() {
  // JOBE-0193: per-route document title.
  useDocumentTitle('Command Center');
  const isRouteEnabled = useFlagStore((s) => s.isFlagOn('wcc.route'));
  // JOBE-0199: styled fallback instead of bare <p>… not enabled</p>.
  if (!isRouteEnabled) return (
    <div className="cc-disabled" data-testid="cc-disabled">
      <DisabledRoutePlaceholder
        featureName="Workforce Command Center"
        flagId="wcc.route"
      />
    </div>
  );
  return (
    <div className="command-center">
      <header className="cc-header"><h1>Workforce Command Center</h1></header>
      <KpiRow /><AttentionList /><RiskHeatMap /><TrendPanel /><RosterTable />
    </div>
  );
}
